"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var content = _interopRequireWildcard(require("@/api/content"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "Policy",
  components: {},
  data: function data() {
    return {
      content: ""
    };
  },
  created: function created() {
    this.getContentSecurity();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    getContentSecurity: function () {
      var _getContentSecurity = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return content.findType({
                type: "SECURITY"
              });
            case 2:
              res = _context.sent;
              this.content = res.data.body;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getContentSecurity() {
        return _getContentSecurity.apply(this, arguments);
      }
      return getContentSecurity;
    }()
  }
};